<info-modal [title]="title" (onOk)="ok()">
	<loading [isLoad]="!details"></loading>

	<table class="table table-sm">
		<thead>
			<tr>
				<th>
					_id
				</th>
				
				<th>
					{{ 'adminstat.common.User' | translate }}
				</th>
				
				<th>
					{{ 'adminstat.common.Email' | translate }}
				</th>
				
				<th *ngIf="type=='sites'">
					{{ 'adminstat.common.Site' | translate }}
				</th>
			</tr>
		</thead>
		
		<tbody>
			<tr *ngFor="let item of details">
				<td>
					{{item.id}}
				</td>
				
				<td>
					{{item.username}}
				</td>
				
				<td>
					<gotosupport [value]="item.email"></gotosupport>
				</td>
				
				<td *ngIf="type=='sites'">
					<site_info [siteUrl]="item.url"></site_info>
				</td>
			</tr>
		</tbody>
	</table>
</info-modal>
